export enum AppConfigKey {
  HospitalName = 'HospitalName',
  HospitalLogo = 'HospitalLogo',
  HospitalAddress = 'HospitalAddress',
  HospitalPhone = 'HospitalPhone',
  HospitalMap = 'HospitalMap',
  WarehouseDepartmentId = 'WarehouseDepartmentId',
  DefaultLanguage = 'DefaultLanguage',
  MaxEquipment = 'MaxEquipment',
}

export const defaultAppConfig: AppConfigMap = {
  HospitalName: '',
  HospitalLogo: '',
  HospitalAddress: '',
  HospitalPhone: '',
  HospitalMap: '',
  WarehouseDepartmentId: '',
  DefaultLanguage: '',
  MaxEquipment: '',
}

export type AppConfigField = {
  key: AppConfigKey
  labelKey: string
  type: 'text' | 'textarea' | 'image' | 'select'
  options?: { label: string; value: string }[]
}

export const APP_CONFIG_FIELDS: AppConfigField[] = [
  {
    key: AppConfigKey.HospitalName,
    labelKey: 'common.setting.name',
    type: 'text',
  },
  {
    key: AppConfigKey.HospitalLogo,
    labelKey: 'common.setting.logo',
    type: 'image',
  },
  {
    key: AppConfigKey.HospitalAddress,
    labelKey: 'common.setting.address',
    type: 'textarea',
  },
  {
    key: AppConfigKey.HospitalPhone,
    labelKey: 'common.setting.phoneNumber',
    type: 'text',
  },
  {
    key: AppConfigKey.HospitalMap,
    labelKey: 'common.setting.map',
    type: 'image',
  },
  {
    key: AppConfigKey.WarehouseDepartmentId,
    labelKey: 'common.setting.mainWarehouse',
    type: 'select',
  },
  {
    key: AppConfigKey.DefaultLanguage,
    labelKey: 'common.setting.defaultLanguage',
    type: 'select',
  },
  {
    key: AppConfigKey.MaxEquipment,
    labelKey: 'common.setting.maxEquipment',
    type: 'text',
  },
]

export interface AppConfig {
  key: AppConfigKey
  value: string
}

export type AppConfigMap = Record<AppConfigKey, string>

export function toAppConfigMap(configs: AppConfig[]): AppConfigMap {
  return {
    ...defaultAppConfig,
    ...Object.fromEntries(configs.map(c => [c.key, c.value])),
  }
}
